<template>
    <div id="unsplash-modal" ref="unsplash-modal" class="modal fade" tabindex="-1" role="dialog" aria-hiddean="true">
        <div class="modal-dialog modal-has-tabs">
            <div class="panel panel-color panel-inverse m-0">
                <div class="panel-heading">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h3 class="panel-title"><i class="zmdi zmdi-calendar-alt m-r-10"></i>
                        {{ trans('global.unsplash_title') }}
                    </h3>
                </div>
            </div>
            <div class="modal-content p-t-0 p-b-0">
                <div class="tabs-nav">
                    <ul class="clearfix">
                        <li v-for="item in tabs"
                            :key="tab.id"
                            class="text-capitalize"
                            :class="{ 'active text-custom': tab === item.tabName }"
                        >
                            <a @click.prevent="tab = item.tabName" :class="{'pointer': tab !== item.tabName}">
                                {{ item.title }}
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="modal-body">
                    <!-- Default Images Tab-->
                    <div class="tab-item" :class="{ 'active': tab === 'default' }">
                        <preloader
                            v-if="defaultImagesLoading"
                        />

                        <unsplash-images
                            @submitImage="handleSubmitImage"
                            :images="defaultImages"
                            :loading="submitting"
                        />
                    </div>

                    <!-- Search Images Tab-->
                    <div class="tab-item" :class="{ 'active': tab === 'search' }">
                        <div class="form-group has-feedback">
                            <i class="fa fa-search form-control-feedback"></i>
                            <input
                                :value="searchQuery"
                                @input="debounceHandler"
                                ref="searchListInput"
                                class="form-control"
                                type="text"
                                :placeholder="trans('app.search')"
                            />
                            <div class="m-t-5 small">
                                <i class="fa fa-info-circle"></i>
                                {{ trans('global.unsplash_note') }}
                            </div>
                        </div>
                        <preloader
                            v-if="searchImagesLoading"
                        />

                        <unsplash-images
                            @submitImage="handleSubmitImage"
                            :loading="submitting"
                            v-else
                            :images="searchImages"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import unsplash from "../../../helpers/unsplash";
import debounce from 'lodash/debounce'
import UnsplashImages from "./UnsplashImages";
import {http} from "../../../http";
import Preloader from "@/system/components/global/Preloader";

export default {
    name: 'UnsplashModal',

    props: {
        type: {
            type: String,
            default: null,
            required: false
        },
    },

    data() {
        return {
            tab: 'default',
            defaultImagesLoading: true,
            defaultImages: null,
            searchImagesLoading: false,
            searchImages: null,
            searchQuery: '',
            debounceHandler: null,
            imageBase64: null,
            query: '',
            submitting: false,
            uploadType: '',
        }
    },

    computed: {
        tabs () {
            return [{
                id: 1,
                tabName: 'default',
                title: this.trans('global.query_images'),
            }, {
                id: 2,
                tabName: 'search',
                title: this.trans('global.search_images'),
            }]
        },
    },

    mounted() {
        // this will be mounted when the main view components like `Calendar`, `Settings` etc. are mounted
        this.modalEventListeners();
    },

    created() {
        // assign the debounce handler to the data property.
        // and bind this vue instance to the handler
        this.debounceHandler = debounce(this.debounceSearch.bind(this), 500);
    },

    methods: {
        async getImages() {
            try {
                this.defaultImages = await unsplash.fetchImages(this.query);
            } catch (e) {
                console.log(e)
            } finally {
                this.defaultImagesLoading = false;
            }
        },

        async debounceSearch(event) {
            this.searchImagesLoading = true;
            try {
                const query = event.target.value;
                this.searchQuery = query;
                this.searchImages = query ? await unsplash.fetchImages(query) : null;
            } catch (e) {
                console.log(e)
            } finally {
                this.searchImagesLoading = false;
            }
        },

        modalEventListeners () {
            this.onModalClose();
            this.onModalOpen();
        },

        onModalClose () {
            const modal = this.$refs['unsplash-modal'];
            $(modal).on('hidden.bs.modal', () => {
                this.resetSearch();
            });
        },

        onModalOpen () {
            /*
            ** 1. Attach an event listener to the modal's shown event
            ** 2. When the modal is shown, get the images
            */
            this.$event_bus.$on('unsplashSearchQuery', (data) => {
                if (!this.defaultImages || this.query !== data) {
                    this.query = data;
                    this.getImages()
                }
            });

            this.$event_bus.$on('unsplashUploadType', (data) => {
                this.uploadType = data;
            });
        },

        async handleSubmitImage(image) {
            try {
                this.submitting = true

                let uploadURL = `/app/unsplash/base64/${image.id}`

                if (this.uploadType === 'async') {
                    uploadURL = `${uploadURL}/${this.type}`
                }

                const { data } = await http.get(uploadURL);

                // async trigger download event for as per unsplash documentation requirements
                http.post(image.download_url);

                // inform the parent component that the image has been uploaded, and send the file data
                const file = this.dataURLtoFile(data, image.id);

                //check if file is online courses or events/gift-cards/online-bookings
                if (this.uploadType === 'async') {
                    this.$event_bus.$emit('handleUnsplashImageOnlineCourse', file);
                } else {
                    // add the unsplash data image from response for the dropify instance
                    const wrapper = $('.dropify-wrapper');
                    const filename = wrapper.find('.dropify-filename-inner');
                    const render = wrapper.find('.dropify-render').html('');

                    wrapper.removeClass('has-error').addClass('has-preview');
                    filename.html(image.id);
                    render.append($("<img src='" + data + "'> </img>"));
                    $('.dropify-preview').css({'display': 'block'});

                    this.$event_bus.$emit('unsplashImageUploaded', file);
                }

                // close the modal
                $(this.$refs['unsplash-modal']).modal('hide');
            } catch ({error, errorBag}) {
                // console.log()
            } finally {
                this.submitting = false
            }
        },

        dataURLtoFile(dataurl, filename){

            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type: mime});
        },

        resetSearch () {
            this.searchImages = null;
            this.searchQuery = '';
            this.tab = 'default';
        },
    },

    beforeUnmount() {
        this.$event_bus.$off('unsplashSearchQuery');
        this.$event_bus.$off('unsplashUploadType');
    },

    components: {
        Preloader,
        UnsplashImages,
    },
}
</script>
